module.exports = __webpack_public_path__ + "static/media/artImage.8f2dcf4f.png";